export const ADD_LICENCES = 'ADD_LICENCES'
export const ADD_LICENCES_DURATION_TYPE = 'ADD_LICENCES_DURATION_TYPE'
export const ADD_LICENCES_TYPE = 'ADD_LICENCES_TYPE'